export function render(_ctx, _cache) {
  return "about";
}